import { gql } from '@apollo/client'
import { isEmpty } from 'ramda'
import React from 'react'

import { placesClient } from '../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../components/helpers/LazyAction'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const usePlaceLevelsState = () => React.useContext(Context) || {}
export const usePlaceLevels = () => usePlaceLevelsState()?.placeLevels || []

const QUERY = gql`
  query PlaceLevels($page: Int, $search: String, $filter: PlaceLevelFilter) {
    placeLevels(page: $page, search: $search, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      levelId
      parentId
      type
      resume
      level {
        id
        name
      }
    }
  }
`

const PlaceLevelLoader = ({ children, search, uncontrolledChildren, perPage: limit, types, levelIds, parentIds }) => {
  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search: search || undefined,
      limit,
      filter: {
        parentIds: !isEmpty(parentIds) ? parentIds : undefined,
        types,
        levelIds
      }
    },
    client: placesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default PlaceLevelLoader
